import { render, staticRenderFns } from "./Usdt3Alert.vue?vue&type=template&id=0f816a1f&"
import script from "./Usdt3Alert.vue?vue&type=script&lang=js&"
export * from "./Usdt3Alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports